import React from "react";
import emailIcon from "../../../../src/asset/images/mail-market.svg";
import { toTitleCase } from "../../../CommonMethhods/CommonMethods";

function ReviewSubmit({ data, onBack, onSubmit }) {

    const handleSubmit = () => {
        const submittedClients = data.filter(
            (client) => client.supportingDoc
        );

        const draftClients = data.filter(
            (client) => !client.supportingDoc
        );

        const confirmationData = {
            submittedCount: submittedClients.length,
            draftCount: draftClients.length,
            generatedSrIds: submittedClients.map(
                (client) => client.serviceRequestId
            ).filter(Boolean),
        };

    onSubmit(confirmationData);
};
    

    return (
        <>
            <div className="review-title-wrap">
                <span className="review-title">Review Summary Before Submission</span>
            </div>
            <div className="step-content">
                <div className="review-wrapper">
                    <table className="review-table">
                        <thead>
                            <tr>
                                <th>Client Name</th>
                                <th>Client Code</th>
                                <th>ISINs</th>
                                <th>No. of Transactions</th>
                                <th>Supporting Doc.</th>
                                <th>Submission Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data?.map((client, index) => (
                                <tr key={index}>
                                    <td>{client?.clientName ? toTitleCase(client?.clientName) : "-"}</td>
                                    <td>{client.clientCode}</td>
                                    <td>{client.isinCount}</td>
                                    <td>{client.totalRecords}</td>

                                    {/* Supporting Doc */}
                                    <td>
                                        {client.supportingDoc  ? (
                                            <span className="status success">Uploaded</span>
                                        ) : (
                                            <span className="status warning">Missing</span>
                                        )}
                                    </td>

                                    {/* Action */}
                                    <td>
                                        {client.supportingDoc ? "Send to Checker" : "Save to Draft"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </div>
            </div>
            <div className="info-banner">
                <img src={emailIcon} alt="email icon"/>
                Email Notification will be sent client
                <span className="banner-text">Upon submission, an automated email will be sent to the Checker (CC: you) with the Service Request details for Suresh Mehta and Anand Joshi.</span>
            </div>

            <div className="footer-actions">
                <button className="back-btn" onClick={onBack}>BACK</button>
                <button className="submit-btns" onClick={handleSubmit}>
                    SUBMIT TO CHECKER
                </button>
            </div>
        </>
    );
}

export default ReviewSubmit;